export default "__VITE_ASSET__eb28cb20__"